export const num = v => Number(v) || 0;
const roundHalfAway = v => Math.sign(v) * Math.round(Math.abs(v)) || 0;
const round2 = v => Math.sign(v) * Math.round((Math.abs(v) + Number.EPSILON) * 100) / 100 || 0;
export const toCents = v => roundHalfAway(round2(num(v)) * 100);
const meterKey = row => {
  var _row$meterSerialNumbe;
  return "".concat(row.unitId, "::").concat((_row$meterSerialNumbe = row.meterSerialNumber) !== null && _row$meterSerialNumbe !== void 0 ? _row$meterSerialNumbe : '');
};
export const groupByMeter = rows => {
  const groups = new Map();
  rows.forEach(row => {
    const key = meterKey(row);
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(row);
  });
  return groups;
};

// Display only: nothing returned here is written back to a row or sent.
export const toSplitRowShares = (rows, _ref) => {
  let splitCents = _ref.splitCents,
    compareRows = _ref.compareRows;
  const groups = groupByMeter(rows);
  const shares = new Map();
  groups.forEach(group => {
    const base = toCents(group[0].baseCharge);
    if (group.some(row => toCents(row.baseCharge) !== base)) return;
    const meterCents = base + toCents(group[0].usageCharge);
    const rowsCents = group.reduce((sum, row) => sum + toCents(row.allocationCharge), 0);
    const coversMeter = rowsCents === meterCents;
    if (!coversMeter && meterCents !== 0) {
      group.forEach(row => {
        const totalCents = toCents(row.allocationCharge);
        const baseShare = roundHalfAway(base * totalCents / meterCents);
        shares.set(row.id, {
          baseCharge: baseShare / 100,
          usageCharge: (totalCents - baseShare) / 100
        });
      });
      return;
    }
    if (group.length < 2) return;
    const ordered = group.sort(compareRows);
    const baseCents = splitCents(base, ordered.map(row => num(row.serviceDaysInPeriod)));
    ordered.forEach((row, pos) => {
      shares.set(row.id, {
        baseCharge: baseCents[pos] / 100,
        usageCharge: (toCents(row.allocationCharge) - baseCents[pos]) / 100
      });
    });
  });
  return shares;
};